module.exports = __webpack_public_path__ + "static/media/1.0deb0c4d.jpg";